/**
 * useIsOrganizationReadOnly Hook
 *
 * True once the organization's trial has lapsed without an active
 * subscription (or a payment has failed past dunning retries) — the
 * same condition the backend's SubscriptionWriteGate enforces server-side.
 * Operational screens (orders/routes/dispatches) should use this to reflect
 * the blocked state client-side; Settings -> Billing must never gate on
 * this, since adding/updating a card is exactly how an org gets out of
 * read-only.
 *
 * This is a client-side *reflection* of server state for UX purposes
 * (disabling buttons, showing a banner) — the backend remains the actual
 * enforcement point regardless of what this hook returns.
 */

import { useMyOrganization, isOrganizationReadOnly } from '@cfleet/api-client';
import { useAuthConfigIfAuthenticated } from './useAuthConfig';

export function useIsOrganizationReadOnly(): boolean {
  const authConfig = useAuthConfigIfAuthenticated();
  const { data: org } = useMyOrganization(authConfig ? { authConfig } : undefined);

  if (!org) return false;
  return isOrganizationReadOnly(org);
}

export default useIsOrganizationReadOnly;
